<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :body="{ class: 'text-center' }"
    :header="{
      img: 'interrogation_mark.svg',
      bgColor: 'primary',
      textColor: 'white',
    }"
  >
    <template #body>
      <h3 class="text-center">
        {{ message }}
      </h3>
      <VeeForm ref="form" @submit="save">
        <QCardSection class="modal-input">
          <fieldset>
            <Field
              v-slot="{ errors, field, value }"
              v-model="reasonId"
              class="q-my-sm"
              tag="div"
              :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@REASONS_NO_SHOW'))"
              :rules="{ required: true }"
            >
              <QField
                v-bind="field"
                :model-value="value"
                :value="reasonId"
                borderless
                class="candidate-multiple-choice-field"
                no-error-icon
                :error="errors.length > 0"
                :error-message="errors[0]"
              >
                <QOptionGroup v-model="reasonId" :options="reasons" color="primary" />
              </QField>
            </Field>
          </fieldset>
        </QCardSection>
        <QCardActions align="center" class="bg-white q-mb-md">
          <QBtn type="submit" :label="$t('ETAB.PAGES.EXTRA.EXTRA_MISSING_DIALOG.@CONFIRM')" color="secondary" class="q-px-lg" no-caps />
        </QCardActions>
      </VeeForm>
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";
  import { Form as VeeForm, Field } from "vee-validate";

  export default {
    components: {
      ExtracadabraModal,
      Field,
      VeeForm,
    },
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      reasons: {
        type: Array,
        default: () => [],
      },
      message: {
        type: String,
        default: "",
      },
    },
    emits: ["update:open", "setReason"],
    data() {
      return {
        reasonId: undefined,
      };
    },
    computed: {
      internalOpen: {
        get() {
          return this.open;
        },
        set() {
          this.$emit("update:open", false);
        },
      },
    },
    watch: {
      open() {
        this.reinitForm();
      },
    },
    methods: {
      reinitForm() {
        this.reasonId = undefined;
      },
      save() {
        this.$emit("setReason", this.reasonId);
      },
    },
  };
</script>
